import { useMemo } from 'react';
import { TreeField } from '@mews-commander/form';
import { TreeOption } from '@mews/b2b-ui';
import { GroupsAndReservationsDialogFormKeys } from './schema';
import { useGroupReservationsSelectionSync } from './useGroupReservationsSelectionSync';

interface GroupsAndReservationsDialogContentProps {
    searchToken?: string;
    setSearchToken: (value: string) => void;
    groupsOptions: TreeOption[];
    groupToReservationMap: Record<string, string[]>;
}

export const GroupsAndReservationsDialogContent = ({
    groupsOptions,
    groupToReservationMap,
    searchToken,
    setSearchToken,
}: GroupsAndReservationsDialogContentProps) => {
    const disabledReservationIds = useGroupReservationsSelectionSync(groupToReservationMap);
    const groupsOptionsWithDisabledReservations = useMemo(
        () =>
            groupsOptions.map((group) => ({
                ...group,
                options: ('options' in group ? group.options : []).map((option) => ({
                    ...option,
                    disabled: 'value' in option && disabledReservationIds.includes(option.value),
                })),
            })),
        [groupsOptions, disabledReservationIds]
    );

    return (
        <TreeField
            name={GroupsAndReservationsDialogFormKeys.groupsAndReservations}
            multiple
            options={groupsOptionsWithDisabledReservations}
            selectionStrategy="check-strictly"
            searchValue={searchToken}
            onSearchChange={(value) => setSearchToken(value.toString())}
            defaultExpandAll
            showSearchBar
            showSelectAllToggle
        />
    );
};
